export default __webpack_public_path__ + "static/services1-cfdcc85ce2812781955db040bfcf59d0.png";